import { autoinject } from 'aurelia-dependency-injection';

export class PluginLoaderConfig {
  plugins: { url: string }[];
  pluginLoaderTimeoutMs: number;
}

@autoinject
export class PluginLoader {
  timedOut = false;

  constructor(private config: PluginLoaderConfig) { }

  loadPlugins = (): Promise<void> => {
    return new Promise<void>((resolve) => {
      const { plugins, pluginLoaderTimeoutMs = 5000 } = this.config;

      if (!plugins || plugins.length === 0) {
        resolve();
        return;
      }

      let scriptsLoading = 0;

      // after a configurable timeout, proceed without waiting for remaining plugins to load
      const timeoutId = window.setTimeout(() => {
        console.warn(`WARNING: Not all plugins loaded within ${pluginLoaderTimeoutMs}ms timeout.`);
        this.timedOut = true;
        resolve();
      }, pluginLoaderTimeoutMs);

      for (const { url } of plugins) {
        scriptsLoading++;

        const script = document.createElement('script');
        script.src = url;

        // set id like "plugin-001" to use for sorting in __registerAsurePortalPlugin()
        script.id = `plugin-${String(scriptsLoading).padStart(3, '0')}`;

        const doneLoading = () => {
          scriptsLoading--;

          if (!this.timedOut && scriptsLoading === 0) {
            // when all plugins have been processed resolve the promise, regardless of whether they
            // all loaded successfully, to ensure a failure in one plugin does not impact the others
            window.clearTimeout(timeoutId);
            resolve();
          }
        };

        script.addEventListener('load', doneLoading);

        script.addEventListener('error', () => {
          console.error(`Failed to load plugin ${url}.`);
          doneLoading();
        });

        document.body.appendChild(script);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/framework/PluginLoader.ts